var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8203 15.666L16.8203 19.666L12.8203 15.666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.819 19.6667V6M22.1523 10.3333H26.1523C26.506 10.3333 26.8451 10.4738 27.0952 10.7239C27.3452 10.9739 27.4857 11.313 27.4857 11.6667V23.6667C27.4857 24.0203 27.3452 24.3594 27.0952 24.6095C26.8451 24.8595 26.506 25 26.1523 25H7.48568C7.13206 25 6.79292 24.8595 6.54287 24.6095C6.29282 24.3594 6.15234 24.0203 6.15234 23.6667V11.6667C6.15234 11.313 6.29282 10.9739 6.54287 10.7239C6.79292 10.4738 7.13206 10.3333 7.48568 10.3333H11.4857",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.05e15a5fee5fe05679097a20f6a13a2d.svg";
export { ForwardRef as ReactComponent };